<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_4"></a>First published in the United States of America in 2014 by Chronicle Books LLC.<br/>First published in the United Kingdom in 2012 by Summersdale.</p>
<p>Text copyright © 2012 by Neil Sinclair and Tara Sinclair.<br/>Illustrations copyright © 2012 by Matt Smith.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>The Library of Congress has cataloged the previous edition as follows:<br/>Sinclair, Neil, 1970-<br/>  Commando dad : a basic training manual for the first three years of fatherhood / by Neil Sinclair.<br/>       pages cm<br/>  ISBN 978-1-4521-2739-2 (pb)<br/>  ISBN 978-1-4521-3220-4 (epub2)<br/>1. Fatherhood. 2. Child rearing. I. Title.</p>
<p>  HQ756.S5446 2014<br/>  306.874’2—dc23</p>
<p>                                                 2013030004</p>
<p>Designed by Sarah Higgins</p>
<p>The information in this book should not be treated as a substitute for qualified medical advice. Always consult a medical practitioner. Neither the author nor the publisher can be held responsible for any loss or claim arising out of the use, or misuse, of the suggestions made or the failure to take medical advice.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com" target="_blank"><span class="hlink">www.chroniclebooks.com</span></a></p>
<p>A percentage of the author’s profits from this book will go to the following charities:</p>
<p>Acorns Children’s Hospice Trust, a registered UK charity offering a network of care and support for life-limited and life-threatened children and young people, and their families.</p>
<p>The National Memorial Arboretum, the UK’s year-round center for Remembrance, a spiritually uplifting place that honors the fallen, recognizes service and sacrifice, and fosters pride in the country. The arboretum is part of the Royal British Legion family of charities.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04copyright.vue?4aecdd78